module.exports = __webpack_public_path__ + "76ab401aeb4bbd26ce489349aae8fcfc.svg";